import Theme from "./theme";

const theme = Theme("light");

export const scrollbarCss = {
    "&::-webkit-scrollbar": {
        width: "2px",
    },
    "&::-webkit-scrollbar-track": {
        backgroundColor: "white",
    },
    "&::-webkit-scrollbar-thumb": {
        backgroundColor: theme.palette.primary.main,
        borderRadius: "10px",
    },
    "&::-webkit-scrollbar-thumb:hover": {
        backgroundColor: theme.palette.primary.main,
    },
};
